import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {websiteMenuList_template} from "../components/templates/websiteMenuList_template";

declare var ko: any;
declare var page: any;

export class website_menu extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected websiteMenuListTemplate: websiteMenuList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.websiteMenuListTemplate = new websiteMenuList_template("websiteMenuList", this.viewModel, this)
        return [this.websiteMenuListTemplate.build()];

    }

    protected getModuleName(): string {
        return "website_menu";
    }

    fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {

        this.loadingIn(this.websiteMenuListTemplate.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let url: string = '/api/brand/' + idBrand + "/website_menu/get/";
        let params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();

    }

    protected onGetFormDataReturn(req, obj) {
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                let data = responseParsed.data;

                obj.websiteMenuListTemplate.setMenu(data, obj.getBrandId());

            });
            obj.loadingOut(obj.websiteMenuListTemplate.builtTemplate.children.namedItem("list-results"));
        }

    }

    public viewMenuItems(id){
        if(id ==3){
            page('/brand/'+ this.getVnAppZone().app.params.idBrand +'/config/header-featured-articles/');

        }else{
            page('/brand/'+ this.getVnAppZone().app.params.idBrand +'/config/menu/edit/'+ id);
        }
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}


// WEBPACK FOOTER //
// ./js/modules/website_menu.ts